import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { Authorization } from 'utils'

import { DealSheetActions } from 'actionsets'
import ResultsWidgetMixin from 'containers/shared/ResultsWidgetMixin'
import { ImageAvatar } from 'components'
import StyleSheet from 'styles'
import { DealsList, DealsCarousel, RoiTable } from 'components/deal_sheet'
import { SegmentedControl, Segment, ConfirmationDialog } from 'components'
import { DialogHandler } from 'utils'
import {FormattedMessage} from 'react-intl'

export class DealsWidget extends ResultsWidgetMixin(Component){

  static propTypes = {
    name:             PropTypes.string,
    title:            PropTypes.string,
    widgetFilter:     PropTypes.object,
    secondaryFilters: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      filter: PropTypes.object.isRequired
    })),
    pageSize:         PropTypes.number,
    renderer:         PropTypes.oneOf(['list', 'carousel','roi_table']),
    carouselSize:     PropTypes.number,
    cardProps:        PropTypes.object,
    renderPaging:     PropTypes.bool,
    secondaryAction:  PropTypes.object,
  }

  static defaultProps = {
    renderer: 'list',
    carouselSize: 3,
    cardProps: {},
    renderPaging: true,
    secondaryAction: null,
    secondaryFilters: []
  }

  constructor(props){
    super(props)
    DealSheetActions.bindActions(this)
    this.state = {
      ...this.state,
      secondaryFilter: (this.props.secondaryFilters.length !== 0) ? this.props.secondaryFilters[0] : { filter: {} }
    }
    this.kycHandler = new DialogHandler(this)
  }

  SecondaryFilter = (props) => {
    const { filters } = props
    return (
      <SegmentedControl active={this.state.secondaryFilter.label} onSelected={this.handleSecondaryFilterChanged}>
        {
          filters.map(({label, filter}) => {
            return <Segment key={label} label={label} value={filter}/>
          })
        }
      </SegmentedControl>
    )
  }

  get filter(){
    const superFilter = super.filter || {}
    const composedFilter = Object.assign(superFilter, this.state.secondaryFilter.filter)
    return composedFilter
  }

  get pageSize() {
    return this.props.pageSize
  }

  handleAddItem = () => {
    this.actions.newRecord()
    this.props.history.push('/deal_sheets/new')
  }

  handleItemSelected = (dealSheet) => {
    this.props.history.push(`/deal_sheets/${dealSheet.id}`)
  }

  handleSecondaryFilterChanged = ({label, value}) => {
    this.setState({secondaryFilter: { label, filter: value }}, this.loadData)
  }

  renderAvatar = (dealSheet) => {
    const { issuerAccountName , emblemUrls } = dealSheet
    return <ImageAvatar alt={ issuerAccountName } urls={ emblemUrls } />
  }

  renderSecondaryFilters = () => {
    const { secondaryFilters } = this.props
    const { SecondaryFilter } = this
    return <SecondaryFilter filters={secondaryFilters}/>
  }

  renderCarousel = (deals) => {
    return (
      <DealsCarousel dealSheets={deals} cardProps={this.props.cardProps} carouselProps={{size: this.props.carouselSize, showNavArrows: true}}/>
    )
  }

  renderResults = results => {
    switch(this.props.renderer){
      case 'list':
        return <DealsList deals={ results } dealSheetDetails={ this.props.dealSheetDetails } fetchDetails={deal => this.actions.fetchDetails(deal.id)}/>
      case 'roi_table':
        return <RoiTable deals={results}/>
      default:
        return this.renderCarousel(results)
    }
  }

  handleNewDealSheet = async() => {
    this.actions.newRecord()
    if (Authorization.issuer)
      this.props.history.push('/deal_sheets/new')
    else if (await this.kycHandler.show() !== undefined)
      this.props.history.push(`/issuer/${Authorization.user.id}/edit`)
  }

  render = () => {
    const { Pagination, Results, Card } = this
    return (
      <Card style={{minHeight: '180px', boxShadow: 'none'}}>
        <div className={styles.widgetHeader}>
          <Typography variant='h4'>
            <FormattedMessage id={this.props.title} />
          </Typography>
          {this.props.match.params.filter === "mine" && Authorization.registeredIssuer &&
            <Button className={styles.addButton} variant='contained' color='primary' onClick={this.handleNewDealSheet}>Create</Button>
          }
          {this.props.secondaryAction &&
            <div className={styles.secondaryAction}>
              {this.props.secondaryAction}
            </div>
          }
        </div>
        {(this.props.secondaryFilters.length !== 0) &&
          <div className={styles.secondaryFilter}>
            {this.renderSecondaryFilters()}
          </div>
        }
        <Results />
        {
          this.props.renderPaging &&
          <Pagination />
        }
        <ConfirmationDialog {...this.kycHandler.props} title="KYC Verification Required" confirmLabel="Verify Me">
          <Typography variant="body1">
            You must complete your KYC verification before you can create new deals.
          </Typography>
        </ConfirmationDialog>
      </Card>
    )
  }

}

const styles = StyleSheet({
  addButton: {
    float: 'right',
  },
  widgetHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    '& h5': {
      paddingRight: 10,
    },
  },
  secondaryAction: {
    textAlign: 'right',
  },
  secondaryFilter: {
    display: 'inline-block',
    marginBottom: '6px',
    '@media(max-width: 480px)': {
      marginBottom: '0px',
      width: '100%'
    },
  }
})

export default connect(({dealSheets}) => dealSheets)(withRouter(DealsWidget))